import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/payback/handle/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const backReturn = (id) => {
  return request({
    url: '/api/payback/handle/backReturn',
    method: 'post',
    params: {
      id,
    },
  });
};

export const backInvoke = (id) => {
  return request({
    url: '/api/payback/handle/backInvoke',
    method: 'post',
    params: {
      id,
    },
  });
};

export const backUpdate = (id) => {
  return request({
    url: '/api/payback/handle/backUpdate',
    method: 'post',
    params: {
      id,
    },
  });
};

export const getAreaList = (shortCode) => {
  return request({
    url: '/api/payback/handle/areaList',
    method: 'get',
    params: {
      shortCode,
    },
  });
};

export const queryPropertyFullName = (id) => {
  return request({
    url: '/api/base/property/detailById',
    method: 'get',
    params: {
      id,
    },
  });
};
